import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from '@swimlane/ngx-datatable';
import { IPatientEmrDetails } from 'src/app/_interfaces/patients/i-patient-emr-details';
import { IpatientVitalsData } from 'src/app/_interfaces/patients/i-patient-vitals-data';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { PatientEmrDetailsService } from 'src/app/_services/patient-emr/patient-emr-details.service';

@Component({
  selector: 'app-vitals-data',
  templateUrl: './vitals-data.component.html',
  styleUrls: ['./vitals-data.component.scss']
})
export class VitalsDataComponent implements OnInit {

  patientId: number = 0;
  patientEmrDetails: IPatientEmrDetails;
  patientVitalsDate: IpatientVitalsData[] = [];
  currentPage: number = 1;
  pageSize: number = 10;
  totalItems: number;
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'Hmm, There is no vital Signs',
    totalMessage: 'total',
    selectedMessage: ''
  };


  constructor(
    private patientEmrDetailsService: PatientEmrDetailsService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
  ) {
    this.patientId = this.activatedRoute.snapshot.params.patientId
  }


  ngOnInit(): void {
    this.getPatientVitals(this.patientId, this.currentPage, this.pageSize)
  }

  getPatientVitals(patientId, currentPage, pageSize) {
    this.patientEmrDetailsService.getPatientAllVitals(patientId, currentPage, pageSize)
      .subscribe(response => {
        this.patientVitalsDate = response.data.items;
        this.totalItems = response.data.pagination.totalItems;
        this.initializeColumn();
      })
  }

initializeColumn() {
  this.columns = [
    {
      prop: 'creationDate',
      name: 'Request Date',
      pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y, h:mm a") },
      width: 200,
      minWidth: 200,
      maxWidth: 300
    },
    {
      prop: 'channelName',
      name: 'Channel',
      pipe: { transform: (val) => val ? val : "--" },
      width: 150,
    },
    {
      prop: 'addedBy',
      name: 'Added By',
      pipe: { transform: (val) => val ? val : "--" },
      width: 150,
    },
    {
      prop: 'randomBloodSugar',
      name: 'Random Blood Glucose',
      pipe: { transform: (val) => val ? val : "--" },
      width: 200,
    },
    {
      prop: 'hbA1C',
      name: 'HBA1C',
      pipe: { transform: (val) => val ? val : "--" },
      width: 150,
    },
    {
      prop: 'height',
      name: 'Height',
      pipe: { transform: (val) => val ? val : "--" },
      width: 120,
    },
    {
      prop: 'weight',
      name: 'Weight',
      pipe: { transform: (val) => val ? val : "--" },
      width: 120,
    },
    {
      prop: 'isSmoker',
      name: 'Smoker',
      pipe: { transform: (val) => val === true ? 'Yes' : val === false ? 'No' : '--' },
      width: 120,
    },
    {
      prop: 'isAlcoholic',
      name: 'Alcoholic',
      pipe: { transform: (val) => val === true ? 'Yes' : val === false ? 'No' : '--' },
      width: 120,
    },
    {
      prop: 'heartRate',
      name: 'Heart Rate',
      pipe: { transform: (val) => val ? val : "--" },
      width: 120,
    },
    {
      prop: 'temperature',
      name: 'Temperature',
      pipe: { transform: (val) => val ? val : "--" },
      width: 150,
    },
    {
      prop: 'respiratoryRate',
      name: 'Respiratory Rate',
      pipe: { transform: (val) => val ? val : "--" },
      width: 160,
    },
    {
      prop: 'oxygenSaturation',
      name: 'Oxygen Saturation',
      pipe: { transform: (val) => val ? val : "--" },
      width: 170,
    },
    {
      prop: 'bloodPressure',
      name: 'Blood Pressure',
      pipe: { transform: (val) => val ? val : "--" },
      width: 160,
    },
    {
      prop: 'bloodType',
      name: 'Blood Type',
      pipe: { transform: (val) => val ? val : "--" },
      width: 120,
    },
    {
      prop: 'emergencyContact',
      name: 'Emergency Contact',
      pipe: { transform: (val) => val ? val : "--" },
      width: 200,
    },
  ];
}



  onChangePage(pageDetails: ISmartTablePagination) {
    this.currentPage = pageDetails.offset + 1;
    this.getPatientVitals(this.patientId, this.currentPage, this.pageSize);
  }

}
